"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getPhrase;

function getPhrase(phrase, args) {
  if (typeof phrase === 'string') return phrase;

  if (typeof phrase === 'function') {
    return phrase(args);
  }

  return '';
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-dates/lib/utils/getPhrase.js
 ** module id = 1822
 ** module chunks = 0
 **/